




import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => any,
    },
  },

  beforeMount() {
    this.$emit('input', {});
  },
});
